import type { FC, ReactElement } from "react"

import { useUpdateEffect } from "react-use"

import { setCurrentAccessToken, setCurrentRefreshToken } from "$/utils/tokens"

import { type TSocialLoginQuery, useSocialLoginQuery } from "@/3514/queries"
import { EStorageServiceType, LocalStorageServiceKeys, StorageService } from "@/services"

const localStorageService: StorageService = new StorageService(EStorageServiceType.Local)

const SocialLoginGuard: FC = (): ReactElement => {
    const { data: socialLoginData, isSuccess: isSocialLoginDataSuccess }: TSocialLoginQuery = useSocialLoginQuery()

    useUpdateEffect((): void => {
        if (isSocialLoginDataSuccess) {
            setCurrentAccessToken(socialLoginData.access)
            void setCurrentRefreshToken(socialLoginData.refresh)
            localStorageService.setItem<boolean>(LocalStorageServiceKeys.SocialComplete(), true)
            localStorageService.removeItem(LocalStorageServiceKeys.MainUserLoggedOut())
            window.location.reload()
        }
    }, [socialLoginData, isSocialLoginDataSuccess])

    return null
}

SocialLoginGuard.displayName = "SocialLoginGuard"

export { SocialLoginGuard }
